export default __webpack_public_path__ + "static/media/Hiroshige_Snowy_landscape_with_woman_&_man_35_x_70_cm.c1b3e5d1.jpg";